import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {emojiToDefinition} from '../../../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {baseEmojiValidationMap} from '../../../../services/emojis/emojis';
import {Banner, BannerTypesEnum} from '../../../common/banners/banner';
import {BannerCloseAction} from '../../../common/banners/bannerCloseAction';
import {BannerContent} from '../../../common/banners/bannerContent';
import {BannerContentTitle} from '../../../common/banners/bannerContentTitle';
import {BannerEmoji} from '../../../common/banners/bannerEmoji';
import {BannerPrioritiesEnum} from '../../../common/banners/bannersContext';

/*
 * Props.
 */

interface TrialRestartedBannerProps {
  onDismissClick: Handler;
}

/*
 * Component.
 */

export const TrialRestartedBanner: FC<TrialRestartedBannerProps> = (props) => {
  const theme = useUserTheme();

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.blue.shade40}
      priority={BannerPrioritiesEnum.INFORMATION}
    >
      <BannerCloseAction onClick={props.onDismissClick} />
      {maybeRenderEmoji()}
      <BannerContent>
        <BannerContentTitle>
          <Trans id="banner-trialrestarted-title">Welcome back!</Trans>
        </BannerContentTitle>
        <Trans id="banner-trialrestarted-description">
          Need more time to try Front? We&apos;ve added 7 extra days to your trial – on us.
        </Trans>
      </BannerContent>
    </Banner>
  );
};

function maybeRenderEmoji() {
  const emojiDefinition = emojiToDefinition('wave', baseEmojiValidationMap);
  if (!emojiDefinition) {
    return null;
  }

  return <BannerEmoji {...emojiDefinition} />;
}
